(function (window) {
  'use strict';

  function initCarousel(carousel) {
    return imagesLoaded(carousel, function () {
      tns({
        container: carousel,
        controlsContainer: carousel.parentNode.querySelector('.js-featured-products-controls'),
        items: 1,
        gutter: 20,
        responsive: {
          661: 2,
          1025: 4,
          // Ensures the carousel is never active at this size. Also involves
          // CSS that overrides the inline carousel CSS. The breakpoint value
          // here should match the breakpoint used in featured-products.scss,
          // currently $page-width-four-cards or 1360px.
          1360: 1000
        },
        slideBy: 'page',
        nav: false,
        loop: false,
        onInit: () => {
          // Forced tabindex="0" to make "prev" and "next" slider buttons keyboard accessible.
          const prevNextButtons = carousel.closest('.featured-products')
            .querySelectorAll('.featured-products__item-control');
          for(let i = 0; i < prevNextButtons.length; i++) {
            prevNextButtons[i].setAttribute('tabindex', 0);
          }
        }
      });
    });
  }

  function init() {
    const featuredProductCarousels = document.querySelectorAll('.js-featured-products-carousel');
    for (let i = 0; i < featuredProductCarousels.length; i++) {
      if (!featuredProductCarousels[i].classList.contains('js-component-init')) {
        initCarousel(featuredProductCarousels[i]);
        featuredProductCarousels[i].classList.add('js-component-init');
      }
    }
  }

  // Allow application JS to reinitialize any instances added with Ajax, etc.
  if (typeof componentEvents !== 'undefined') {
    componentEvents.on('component-init', init);
  }

  init();

})(this);
